import { handleActions, Reducer } from "redux-actions";
import {
    ACTION_GETINSTITUTION_SUCCESS,
    ACTION_UPDATEINSTITUTION_SUCCESS,
    ACTION_UPDATELOGO_SUCCESS,
    SAVE_REPORT_PAGE_DATA,
    GET_EXAMINER_RESULT,
    ReportData
} from "../actions/institution";
import { ExamineeResult } from "../../api/base/examination/examination";

export interface institutionState {
    institution: any
    reportPageData: ReportData
    examinerResult: Array<ExamineeResult>
}

const defaultState: institutionState = {
    institution: {
        name:"",
        logo:""
    },
    reportPageData: Object.assign({}),
    examinerResult: [],
}

function handleActionGetInstitutionSuccess(state: institutionState, action: any): institutionState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        institution: action.payload.data
    };
}
function handleActionSaveReportPageData(state: institutionState, action: any): institutionState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        ...action.payload,
    };
}
function getExaminerResultSuccess(state: institutionState, action: any): institutionState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        ...action.payload
    };
}

function handleActionUpdateInstitutionSuccess(state: institutionState, action: any): institutionState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    };
}

function handleActionUpdateLogoSuccess(state: institutionState, action: any): institutionState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    };
}

export const institutionReducer: Reducer<institutionState, any> = handleActions(
    {
        [ACTION_GETINSTITUTION_SUCCESS]: handleActionGetInstitutionSuccess,
        [ACTION_UPDATEINSTITUTION_SUCCESS]: handleActionUpdateInstitutionSuccess,
        [ACTION_UPDATELOGO_SUCCESS]: handleActionUpdateLogoSuccess,
        [SAVE_REPORT_PAGE_DATA]: handleActionSaveReportPageData,
        [GET_EXAMINER_RESULT]: getExaminerResultSuccess
    },
    defaultState
);
